module.exports = __webpack_public_path__ + "img/game649_blank.bc72d27d.png";